module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-planning",
    class: {
      'loaded': _vm.data && !_vm.data.created_budget
    }
  }, [(_vm.data && !_vm.data.created_budget) ? _c('div', {
    staticClass: "floater"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "goal-ebitda col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.ebitdagoal) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.ebitda.goal)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v(" "), _c('div', [_vm._v("\n                        Ønsket EBITDA (driftsoverskud)\n                        "), _c('br'), _vm._v(" "), (_vm.stepsInitiated.coverageperhour) ? _c('span', [_vm._v("\n                            Beregnet EBITDA: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.resultList[_vm.resultList.length - 1].budget)))])]) : _c('span', [_vm._v("\n                            -\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "demand-for-zero-revenue col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.expenses && _vm.stepsInitiated.hours) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.demandForZeroRevenue)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v("\n                    DB pr. time for at nå\n                    "), _c('br'), _vm._v("\n                    nulpunktsomsætning\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "demand-for-goal col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.expenses && _vm.stepsInitiated.ebitdagoal && _vm.stepsInitiated.hours) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.demandForGoal)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v("\n                    DB pr. time for at nå\n                    "), _c('br'), _vm._v("\n                    ønsket EBITDA\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "calculated-coverage-per-hour col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [(_vm.stepsInitiated.coverageperhour) ? _c('div', {
    staticClass: "lg",
    class: {
      'good': _vm.displayedCoveragePerHour >= Math.ceil(_vm.demandForGoal), 'neutral': _vm.displayedCoveragePerHour > Math.ceil(_vm.demandForZeroRevenue), 'bad': _vm.displayedCoveragePerHour < Math.ceil(_vm.demandForZeroRevenue)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.displayedCoveragePerHour)) + "\n                    ")]) : _c('div', {
    staticClass: "lg"
  }, [_vm._v("\n                        -\n                    ")]), _vm._v("\n                    Beregnet DB pr. time\n                    "), _c('br'), _vm._v("\n                    (ud fra dine indtastninger)\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showExpensesModal) ? _c('div', {
    staticClass: "expenses-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                Underkonti for \"" + _vm._s(_vm.showExpensesModal.name) + "\"\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "inner__list"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updatingBudget),
      expression: "!updatingBudget"
    }],
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Historisk")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.showExpensesModal.input_type === 'total') ? _c('d-tooltip', {
    attrs: {
      "identifier": "budgetplanning.pencil.modal",
      "placement": "inline",
      "icon": "pencil"
    },
    on: {
      "clicked": function($event) {
        _vm.showExpensesModal.input_type = 'accounts'
      }
    }
  }) : _vm._e(), _vm._v("\n                                Budget\n                            ")], 1)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.showExpensesModal.accounts.filter(function (x) { return x.entries_total !== 0; })), function(account, index) {
    return _c('tr', {
      key: 'account_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.updatingBudget),
        expression: "!updatingBudget"
      }],
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(account.entries_total)))]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [(_vm.showExpensesModal.input_type === 'accounts') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (account.budget),
        callback: function($$v) {
          _vm.$set(account, "budget", $$v)
        },
        expression: "account.budget"
      }
    }) : _c('span', {
      staticStyle: {
        "display": "block",
        "padding": "4px"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(account.budget)) + "\n                                ")])], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updatingBudget),
      expression: "!updatingBudget"
    }],
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.showExpensesModal.entries_total)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.showExpensesModal.accounts, 'budget'))))])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.closeExpensesModal(_vm.showExpensesModal.slug)
      }
    }
  }, [_vm._v("\n                    Luk\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('box-helper', {
    attrs: {
      "headline": "Budgetlægning",
      "identifier": "budgetPlanning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Budgetlægning</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Læg dit budget\n            ")])]), _vm._v(" "), (_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "20px",
      "background": "#172b43",
      "color": "#fff",
      "border-radius": "4px",
      "font-size": "14px"
    }
  }, [_vm._v("\n            OBS! Du er ved at opdatere dit eksisterende budget. Ønsker du at lægge et nyt budget, skal du gå til fanebladet Overblik og herefter vælge fanebladet Læg budget igen.\n            "), _c('br'), _vm._v("\n            Hust at trykke Gem, når du er færdig med at ændre budgettet.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.data && !_vm.data.created_budget) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.updatingBudget) ? _c('div', [_vm._v("\n                        Du er nu ved at ændre budgettet for perioden:\n                    ")]) : _c('div', [_vm._v("\n                        Du er nu ved at lægge budget for perioden:"), _c('br')]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.periods.budget.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.periods.budget.to, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n                    Du kigger på data fra perioden:"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.periods.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.periods.data.to, 'DD/MM/YYYY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "step-switcher",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 1
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("\n                        1. Omkostninger\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 2
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("\n                        2. Ønsket EBITDA (driftsoverskud)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 3
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("\n                        3. Solgte timer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 4
    },
    on: {
      "click": function($event) {
        _vm.step = 4
      }
    }
  }, [_vm._v("\n                        4. DB pr. time\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 5
    },
    on: {
      "click": function($event) {
        _vm.step = 5
      }
    }
  }, [_vm._v("\n                        5. Resultat\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-expenses"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.expenses
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.expenses",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.expenses) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Omkostninger\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.expenses) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.expenses"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.expenses = true
      }
    }
  }, [_vm._v("\n                            Kom i gang\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.expenses && _vm.stepsCompleted.expenses) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Du har sat dine forventede omkostninger til "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalExpenses)))])]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "options": _vm.expensesGraphOptions,
      "series": _vm.totalExpensesPeriodisedSeries,
      "type": "bar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.expenses = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.expenses && !_vm.stepsCompleted.expenses) ? _c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget\n                                        ")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.expensesAccountCategories), function(accountCategory, index) {
    return _c('tr', {
      key: 'accountCategory_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [(accountCategory.accounts.length > 0) ? _c('i', {
      staticClass: "fas fa-list fa-fw expense-icon",
      on: {
        "click": function($event) {
          return _vm.openExpensesModal(accountCategory)
        }
      }
    }) : _c('i', {
      staticClass: "fas fa-list fa-fw expense-icon",
      staticStyle: {
        "opacity": "0"
      }
    }), _vm._v("\n                                        " + _vm._s(accountCategory.name) + "\n                                        "), (accountCategory.slug === 'vareforbrug') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.materials.diff",
        "placement": "inline"
      }
    }), _vm._v(" \n                                            "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: ("\n                                                    Ifølge sagsstyringssystemet har du brugt <b>" + (_vm.data.differences.materials.ordersystem > 0 ? '-' : '') + (_vm.$options.filters.currency(_vm.data.differences.materials.ordersystem)) + "</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>" + (_vm.$options.filters.currency(_vm.data.differences.materials.economic)) + "</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Det giver en difference på <b>" + (_vm.$options.filters.currency(_vm.data.differences.materials.diff)) + "</b>\n                                                ")
        }),
        expression: "{\n                                                content: `\n                                                    Ifølge sagsstyringssystemet har du brugt <b>${data.differences.materials.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.materials.ordersystem)}</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.materials.economic)}</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Det giver en difference på <b>${$options.filters.currency(data.differences.materials.diff)}</b>\n                                                `\n                                            }"
      }],
      staticClass: "fas fa-calculator",
      staticStyle: {
        "opacity": "0.5"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (accountCategory.slug === 'lonninger-svende') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.employees.diff",
        "placement": "inline"
      }
    }), _vm._v(" \n                                            "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: ("\n                                                    Ifølge sagsstyringssystemet har du brugt <b>" + (_vm.data.differences.employees.ordersystem > 0 ? '-' : '') + (_vm.$options.filters.currency(_vm.data.differences.employees.ordersystem)) + "</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>" + (_vm.$options.filters.currency(_vm.data.differences.employees.economic)) + "</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Det giver en difference på <b>" + (_vm.$options.filters.currency(_vm.data.differences.employees.diff)) + "</b>\n                                                ")
        }),
        expression: "{\n                                                content: `\n                                                    Ifølge sagsstyringssystemet har du brugt <b>${data.differences.employees.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.employees.ordersystem)}</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.employees.economic)}</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Det giver en difference på <b>${$options.filters.currency(data.differences.employees.diff)}</b>\n                                                `\n                                            }"
      }],
      staticClass: "fas fa-calculator",
      staticStyle: {
        "opacity": "0.5"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (accountCategory.slug === 'underleverandorer') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.subcontractors",
        "placement": "inline"
      }
    }), _vm._v(" \n                                        ")], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.old_budget)) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.entries_total)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'edited-lower': _vm.updatingBudget && accountCategory.old_budget > accountCategory.budget, 'edited-higher': _vm.updatingBudget && accountCategory.old_budget < accountCategory.budget
      },
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.input_type === 'total') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (accountCategory.budget),
        callback: function($$v) {
          _vm.$set(accountCategory, "budget", $$v)
        },
        expression: "accountCategory.budget"
      }
    }) : _c('span', {
      staticStyle: {
        "display": "block",
        "padding": "4px"
      }
    }, [_c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.pencil.expenses",
        "placement": "inline",
        "icon": "pencil"
      },
      on: {
        "clicked": function($event) {
          accountCategory.input_type = 'total'
        }
      }
    }), _vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.budget)) + "\n                                        ")], 1)], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.totalHistoricExpenses > 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totalHistoricExpenses)))]), _vm._v(" "), _c('td', {
    staticClass: "budget",
    class: {
      'edited-lower': _vm.updatingBudget && _vm.totalHistoricExpenses > (_vm.totalExpenses * -1), 'edited-higher': _vm.updatingBudget && _vm.totalHistoricExpenses < (_vm.totalExpenses * -1)
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.totalExpenses > 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totalExpenses)))])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"omkostninger\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentExpenses),
      expression: "commentExpenses"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentExpenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentExpenses = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('expenses', 'step-expenses')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-ebitdagoal"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.ebitdagoal
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.goal",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.ebitdagoal) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Ønsket EBITDA (driftsoverskud)\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.stepsInitiated.ebitdagoal) ? _c('div', [(_vm.stepsCompleted.expenses) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.goal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.ebitdagoal = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld dine forventede omkostninger for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.ebitdagoal && _vm.stepsCompleted.ebitdagoal) ? _c('div', [_c('div', [_vm._v("Du har sat dit ønskede EBITDA til")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.ebitda.goal)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.ebitdagoal = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.ebitdagoal && !_vm.stepsCompleted.ebitdagoal) ? _c('div', [(_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(0), _vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.ebitda.old_goal)) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Rettet budget:")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "autonumeric-wrap",
    class: {
      'edited-higher': _vm.updatingBudget && _vm.data.ebitda.goal > _vm.data.ebitda.old_goal, 'edited-lower': _vm.updatingBudget && _vm.data.ebitda.goal < _vm.data.ebitda.old_goal
    }
  }, [_c('vue-autonumeric', {
    attrs: {
      "options": {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: '\u00a0kr.',
        currencySymbolPlacement: 's',
        roundingMethod: 'U',
        decimalPlaces: 0
      }
    },
    model: {
      value: (_vm.data.ebitda.goal),
      callback: function($$v) {
        _vm.$set(_vm.data.ebitda, "goal", $$v)
      },
      expression: "data.ebitda.goal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"ønsket EBITDA\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentEbitda),
      expression: "commentEbitda"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentEbitda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentEbitda = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('ebitdagoal', 'step-ebitdagoal')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-hours"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.hours
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.hours",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.hours) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Solgte timer\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.stepsCompleted.ebitdagoal) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.hours"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.hours = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld dit ønskede EBITDA for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.hours && _vm.stepsCompleted.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("Du har sat forventede antal solgte timer til")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.totalHours)))]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "options": _vm.hoursGraphOptions,
      "series": _vm.totalHoursPeriodisedSeries,
      "type": "bar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.hours = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.hours && !_vm.stepsCompleted.hours) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "30px"
    }
  }, [_c('div', [_vm._v("\n                                Gennemsnitlig tid hos kunderne i perioden: "), _c('b', [_vm._v(_vm._s(_vm._f("number")((_vm.sum(_vm.employeesInPeriod, 'hours') / _vm.sum(_vm.employeesInPeriod, 'available_hours')) * 100)) + "%")]), _vm._v(" "), _c('br'), _vm._v("\n                                Beregnet gennemsnitlig tid hos kunderne ud fra din indtastning: "), _c('b', [_vm._v(_vm._s(_vm._f("number")(_vm.percentageHoursWithCustomers)) + "%")])]), _vm._v(" "), (!_vm.updatingBudget && _vm.hoursCalcType === 'projectTypes') ? _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.hoursCalcType = 'employees'
      }
    }
  }, [_vm._v("\n                                Tryk her for at budgettere solgte timer ud fra medarbejdere i stedet\n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.updatingBudget && _vm.hoursCalcType === 'employees') ? _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.hoursCalcType = 'projectTypes'
      }
    }
  }, [_vm._v("\n                                Tryk her for at budgettere solgte timer ud fra opgavetyper i stedet\n                            ")]) : _vm._e()]), _vm._v(" "), (_vm.hoursCalcType === 'projectTypes') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.hours.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'projectTypeHour_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(projectType.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (projectType.budget),
        callback: function($$v) {
          _vm.$set(projectType, "budget", $$v)
        },
        expression: "projectType.budget"
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.project_types, 'hours'))))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.project_types, 'budget'))))])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.hoursCalcType === 'employees') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Medarbejder")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Timer til rådighed")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Kundetid (nuv. budget)\n                                        ")]) : _c('span', [_vm._v("\n                                            Kundetid historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Budget kundetid")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Solgte timer historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget solgte timer\n                                        ")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.hours.employees), function(employee, index) {
    return _c('tr', {
      key: 'employeeHour_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(employee.name === 'Planlagt ansættelse af nye svende' ? 'Planlagt ansættelse eller afskedigelse af svende/lærlinge' : employee.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(employee.available_hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.old_hours_with_project_percent)) + "%    \n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.hours_with_project_percent_historic)) + "%\n                                        ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "30px"
      },
      attrs: {
        "align": "right"
      }
    }, [(employee.name === 'Planlagt ansættelse af nye svende') ? _c('div', [_vm._v("\n                                            -\n                                        ")]) : _c('div', {
      staticClass: "slider",
      staticStyle: {
        "margin": "0",
        "display": "flex",
        "align-items": "center"
      }
    }, [(employee.budget_type === 'percent') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.hours_with_project_percent),
        expression: "employee.hours_with_project_percent"
      }],
      attrs: {
        "type": "range",
        "min": 0,
        "max": 125
      },
      domProps: {
        "value": (employee.hours_with_project_percent)
      },
      on: {
        "input": function($event) {
          employee.budget = (employee.hours_with_project_percent / 100) * employee.available_hours
        },
        "__r": function($event) {
          return _vm.$set(employee, "hours_with_project_percent", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (employee.budget_type === 'percent') ? _c('div', {
      staticStyle: {
        "padding-left": "5px",
        "width": "50px",
        "flex-shrink": "0"
      }
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("number")(employee.hours_with_project_percent)) + "%\n                                            ")]) : _vm._e(), _vm._v(" "), (employee.budget_type === 'input') ? _c('div', {
      staticStyle: {
        "padding": "11px 0"
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil",
      staticStyle: {
        "opacity": "0.75"
      },
      on: {
        "click": function($event) {
          employee.budget_type = 'percent'
        }
      }
    }), _vm._v("\n                                                " + _vm._s(_vm._f("number")(employee.hours_with_project_percent)) + "%\n                                            ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.old_budget)) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.hours)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'edited-higher': _vm.updatingBudget && employee.budget > employee.old_budget, 'edited-lower': _vm.updatingBudget && employee.budget < employee.old_budget
      },
      attrs: {
        "align": "right"
      }
    }, [(employee.budget_type === 'input') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (employee.budget),
        callback: function($$v) {
          _vm.$set(employee, "budget", $$v)
        },
        expression: "employee.budget"
      }
    }) : _vm._e(), _vm._v(" "), (employee.budget_type === 'percent') ? _c('div', [_c('i', {
      staticClass: "fas fa-pencil",
      staticStyle: {
        "opacity": "0.75"
      },
      on: {
        "click": function($event) {
          employee.budget_type = 'input'
        }
      }
    }), _vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.budget)) + "\n                                        ")]) : _vm._e()], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'old_budget'))) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'hours'))) + "\n                                        ")])]), _vm._v(" "), _c('td', {
    class: {
      'edited-higher': _vm.updatingBudget && _vm.sum(_vm.data.hours.employees, 'old_budget') < _vm.sum(_vm.data.hours.employees, 'budget'), 'edited-lower': _vm.updatingBudget && _vm.sum(_vm.data.hours.employees, 'old_budget') > _vm.sum(_vm.data.hours.employees, 'budget')
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'budget'))) + "\n                                    ")])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"solgte timer\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentHours),
      expression: "commentHours"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('hours', 'step-hours')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-coverageperhour"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.coverageperhour
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.coverageperhour",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.coverageperhour) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    DB pr. time\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.coverageperhour) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.stepsCompleted.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.coverageperhour"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.coverageperhour = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld forventet antal solgte timer for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.coverageperhour && _vm.stepsCompleted.coverageperhour) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("Dit beregnede DB pr. time er")]), _vm._v(" "), _c('div', {
    class: {
      'good': _vm.displayedCoveragePerHour >= Math.ceil(_vm.demandForGoal), 'neutral': _vm.displayedCoveragePerHour > Math.ceil(_vm.demandForZeroRevenue), 'bad': _vm.displayedCoveragePerHour < Math.ceil(_vm.demandForZeroRevenue)
    },
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.displayedCoveragePerHour)) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.coverageperhour = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.coverageperhour && !_vm.stepsCompleted.coverageperhour) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                            Gennemsnitligt DB pr. time historisk: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.coveragePerHourHistoric)))])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. antal timer pr. opgave")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            DB pr. time historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. ekstra pris pr. opgave")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.coverage_per_hour.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'cphProjectType_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(projectType.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours_with_ongoing)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)))]), _vm._v(" "), (!_vm.updatingBudget) ? _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.coverage_per_hour > _vm.demandForGoal) ? _c('span', {
      staticClass: "good",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : (projectType.coverage_per_hour > _vm.demandForZeroRevenue) ? _c('span', {
      staticClass: "neutral",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "bad",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")])]) : _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.old_budget_coverage_per_hour > _vm.demandForGoal) ? _c('span', {
      staticClass: "good",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")]) : (projectType.old_budget_coverage_per_hour > _vm.demandForZeroRevenue) ? _c('span', {
      staticClass: "neutral",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "bad",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_c('div', {
      class: {
        'good': projectType.budget_coverage_per_hour > _vm.demandForGoal, 'neutral': projectType.budget_coverage_per_hour > _vm.demandForZeroRevenue, 'bad': projectType.budget_coverage_per_hour < _vm.demandForZeroRevenue
      },
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (projectType.budget_coverage_per_hour),
        callback: function($$v) {
          _vm.$set(projectType, "budget_coverage_per_hour", $$v)
        },
        expression: "projectType.budget_coverage_per_hour"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [(((projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")((projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0))) + "\n                                        ")]) : _c('span', [(((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0))) + "\n                                        ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"DB pr. time\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentCPH),
      expression: "commentCPH"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentCPH)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentCPH = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('coverageperhour', 'step-coverageperhour')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-result"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Resultat\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.allStepsCompleted) ? _c('div', {
    staticStyle: {
      "opacity": "0.5",
      "font-style": "italic",
      "text-align": "center"
    }
  }, [_vm._v("\n                        Udfyld omkostninger, ønsket EBITDA, solgte timer samt DB pr. time for at se det endelige resultat her\n                    ")]) : _c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), (!_vm.updatingBudget) ? _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Historisk")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Nuv. budget")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("Nyt budget")]) : _c('span', [_vm._v("Budget")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Forskel\n                                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultList), function(accountCategory, index) {
    return _c('tr', {
      key: 'resultAccountCategory_' + index
    }, [_c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "left"
      }
    }, [_vm._v("\n                                        " + _vm._s(accountCategory.name) + "\n                                    ")]), _vm._v(" "), (!_vm.updatingBudget) ? _c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.total)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.oldBudget)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.budget)) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      staticStyle: {
        "font-style": "italic"
      },
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [(Math.round(accountCategory.budget) > Math.round(accountCategory.oldBudget)) ? _c('span', {
      staticClass: "good"
    }, [_vm._v("\n                                                +" + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.oldBudget)) + "\n                                            ")]) : (Math.round(accountCategory.budget) < Math.round(accountCategory.oldBudget)) ? _c('span', {
      staticClass: "bad"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.oldBudget)) + "\n                                            ")]) : _c('span', [_vm._v("\n                                                -\n                                            ")])]) : _c('span', [(Math.round(accountCategory.budget) > Math.round(accountCategory.total)) ? _c('span', {
      staticClass: "good"
    }, [_vm._v("\n                                                +" + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.total)) + "\n                                            ")]) : (Math.round(accountCategory.budget) < Math.round(accountCategory.total)) ? _c('span', {
      staticClass: "bad"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.total)) + "\n                                            ")]) : _c('span', [_vm._v("\n                                                -\n                                            ")])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til dette budget\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.saveBudget()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-save fa-fw"
  }), _vm._v("\n                                Gem budget\n                            ")])])])])])]) : (_vm.data && _vm.data.created_budget) ? _c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            Der er lagt et budget for perioden:"), _c('br'), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.created_budget.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.created_budget.to, 'DD/MM/YYYY')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n            Budgettet blev lagt:"), _c('br'), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.created_budget.created_at, 'DD/MM/YYYY [kl.] HH:mm')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.data.created_budget.comment) ? _c('div', [_c('div', [_vm._v("Din egen kommentar til budgettet:")]), _vm._v(" "), _c('pre', {
    staticStyle: {
      "display": "block",
      "border": "1px solid #ccc",
      "padding": "15px",
      "border-radius": "4px",
      "width": "50%",
      "margin": "10px auto 0 auto",
      "font-family": "inherit",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.data.created_budget.comment))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.data.created_budget = null
      }
    }
  }, [_vm._v("\n                Læg et nyt budget\n            ")]), _vm._v(" "), (_vm.data.created_budget.data) ? _c('span', [_vm._v("\n                  \n                "), _c('a', {
    staticClass: "budget-btn",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/budget-laegning?update=1"
    }
  }, [_vm._v("\n                    Ret eksisterende budget\n                ")])]) : _vm._e()]) : _c('div', [_c('box-loading')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Nuv. budget:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. antal timer pr. opgave")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Solgte timer historisk")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Budget solgte timer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Antal timer\n                                        "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "opacity": "0.5"
    }
  }, [_vm._v("afsluttede opgaver")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Antal timer\n                                        "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "opacity": "0.5"
    }
  }, [_vm._v("inkl. igangv. opgaver")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0871cc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/budget/index.vue
// module id = 931
// module chunks = 0